var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaiver(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.781 8.84253L7.36154 6.90595L5.95324 8.84253L4.64736 6.90595L3.31009 8.84253L2.00867 6.78155V2.44322C2.00865 2.32895 2.00448 2.21473 1.99592 2.10078C1.99592 2.10078 2.9652 2.10101 6.17779 2.10078C9.48616 2.26405 8.781 8.84253 8.781 8.84253Z",
    fill: "#8E909E",
    fillOpacity: 0.2,
    stroke: "#8E909E",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85669 2.06478C5.97537 1.99249 11.9575 1.9807 21.8031 2.02942C25.2291 2.04713 27.9959 4.49215 27.9959 7.50214V26.0512L25.7835 27.9961L24.3086 26.0512L22.9003 27.9961L21.3479 26.0512L19.8334 27.9961L18.393 26.0512L16.9341 27.9961L15.4091 26.0512L13.9173 27.9961L12.5569 26.0512L10.9866 27.9961L8.82214 26.0512V8.49902",
    stroke: "#8E909E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8639 9.51434C15.8639 8.75285 15.2816 8.17053 14.5201 8.17053C13.7586 8.17053 13.1763 8.75285 13.1763 9.51434C13.1763 10.2758 13.7586 10.8581 14.5201 10.8581C15.2816 10.8581 15.8639 11.4405 15.8639 12.202C15.8639 12.9634 15.2816 13.5458 14.5201 13.5458C13.7586 13.5458 13.1763 12.9634 13.1763 12.202",
    stroke: "#8E909E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.52 6.82654V7.49844",
    stroke: "#8E909E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5203 14.2186V14.8905",
    stroke: "#8E909E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8064 17.9147H22.6265",
    stroke: "#8E909E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8044 7.83459H22.5839",
    stroke: "#8E909E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8044 11.1946H22.5839",
    stroke: "#8E909E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8044 14.5546H22.5839",
    stroke: "#8E909E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8064 21.2747H22.6265",
    stroke: "#8E909E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiver);
export default __webpack_public_path__ + "static/media/waiver.16e0a33df5b1bdcb5bcc2af5cff8aedd.svg";
export { ForwardRef as ReactComponent };